export default "__VITE_ASSET__4ca48092__"